<template>
  <div>
    <b-card>
      <b-row>
        <b-col cols="12" md="12" lg="12">
          <b-tabs v-model="activeTab" @input="onTabChange" fill content-class="mt-3" align="center" style="min-height: 75vh">
            <b-tab title="Profil" active>
              <tab-profil :data="data" :asuransi="asuransi" @alertFromChild="triggerAlert($event)" :activeTab="activeTab" />
            </b-tab>
            <b-tab title="Absensi">
              <tab-absensi :data="data" :activeTab="activeTab" />
            </b-tab>
            <!-- <b-tab title="Penilaian">
              <tab-penilaian :activeTab="activeTab"/>
            </b-tab> -->
            <b-tab title="Pelanggaran">
              <tab-pelanggaran :data="data" @change="change = !change" :activeTab="activeTab" />
            </b-tab>
            <b-tab title="Peringatan">
              <tab-peringatan :data="data" :change="change" :activeTab="activeTab" />
            </b-tab>
            <!-- <b-tab title="Perjanjian">
              <tab-perjanjian :activeTab="activeTab"/>
            </b-tab> -->
            <b-tab v-if="data.statusKerjaKaryawan == 0 && role == 'super'" title="Penggajian">
              <tab-penggajian :data="data" :activeTab="activeTab" />
            </b-tab>
          </b-tabs>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import tabProfil from "./profil/tabProfil.vue";
import tabAbsensi from "./absensi/tabAbsensiKedatangan.vue";
// // import tabPenilaian from "../../../../component/hcms/karyawan/tabPenilaian.vue";
import tabPelanggaran from "./pelanggaran/tabPelanggaran.vue";
import tabPeringatan from "./peringatan/tabPeringatan.vue";
// // import tabPerjanjian from "../../../component/hcms/karyawan/tabPerjanjian.vue";
import tabPenggajian from "./penggajian/tabPenggajian.vue";
export default {
  name: "DataKaryawanBelum",
  props: ["edit"],
  components: {
    tabProfil,
    tabAbsensi,
    // // tabPenilaian,
    tabPelanggaran,
    tabPeringatan,
    // // tabPerjanjian,
    tabPenggajian,
  },
  data() {
    return {
      showing: false,
      variant: "success",
      msg: "",
      change: false,
      asuransi: [],
      activeTab: 0,
      data: {},
    };
  },
  computed: {
    role() {
      return this.$store.state.role_aktif ? this.$store.state.role_aktif.kodeRole : null;
    },
  },
  mounted() {
    this.getDatas();
  },
  watch: {
    edit: function (newVal, oldVal) {
      if (oldVal != newVal) {
        // console.log(this.data, "ini datanya");
      }
    },
  },
  methods: {
    onTabChange(newIndex) {
      const titles = ["Profil", "Absensi", "Pelanggaran", "Peringatan", "Penggajian"];

      console.log("Tab title:", titles[newIndex]);
    },
    async getDatas() {
      let vm = this;
      let detailKaryawan = await vm.$axios.get("dataKaryawan/detailsByDataKaryawanId/" + vm.$route.query.dataKaryawanId);
      vm.data = detailKaryawan.data.data[0];
      vm.data.dataKaryawanId = vm.$route.query.dataKaryawanId;

      let listAsuransi = await vm.$axios.post("masterAsuransi/list");
      // console.log("listAsuransi", listAsuransi);
      vm.asuransi = listAsuransi.data.data.map((x) => {
        return {
          ...x,
          id: x.masterAsuransiId,
        };
      });
    },
    triggerAlert(event) {
      const vm = this;
      vm.$store.commit("set_alert", event);
    },
  },
};
</script>
